export default __webpack_public_path__ + "942a6107bf4cb85ae61422aad0096e13.png";